// facilitySearch.js

import { filterPinsByName } from "./map";

const searchBox = document.getElementById('facilitySearch');
// Function to handle facility search
const handleFacilitySearch = () => {
  const searchQuery = document.getElementById('facilitySearch').value;
  filterPinsByName(searchQuery);
};

// Add event listener for input event on the facility search field
document.getElementById('facilitySearch').addEventListener('input', handleFacilitySearch);

// Function to clear search box
const clearSearch = () => {
  document.getElementById('facilitySearch').value = "";
  searchBox.dispatchEvent(new Event("input"));
}

const clearSearchButton = document.querySelector("#clearSearchButton");
clearSearchButton.addEventListener('click', clearSearch);



